import {
    DTOCardFormField,
} from 'app/types/form.types'
import {
    OperationalDays,
} from 'app/enums/label.enums'
import {
    ServiceCenterFormType,
} from 'app/Apps/ContainerManagement/ServiceCenters/serviceCenters.types'
import {
    SizeLink, TypeLink,
} from 'app/shared-components/SkyNetLink'
import {
    ChangeRequestApprovalType,
} from 'app/Apps/OrderManagement/Orders/orders.types'

const getFields = ({
    serviceCenter,
    getAllowedValues,
    serviceCenterNumberLink,
}: {
    serviceCenter: ServiceCenterFormType,
    getAllowedValues: (enumType: Record<string, string>) => Record<string, string>,
    serviceCenterNumberLink: string
}): DTOCardFormField<keyof (ChangeRequestApprovalType & ServiceCenterFormType)>[] => {
    return [{
        id: 'generalInformation',
        className: 'generalInformation',
        title: 'General Information',
        fields: [
            {
                id: 'confirm_order_column_1',
                fields: [
                    {
                        name: 'selectedOriginServiceCenter',
                        componentName: 'LocationObjectSelector',
                        labelKey: 'ServiceCenter.location',
                    },
                    {
                        name: 'serviceCenterNumber',
                        componentName: 'SkyNetLink',
                        type: TypeLink.EXTERNAL,
                        size: SizeLink.S,
                        text: serviceCenter?.serviceCenterNumber,
                        link: serviceCenterNumberLink,
                        labelKey: 'ServiceCenter.serviceCenterNumber',
                    },
                    {
                        name: 'productMetrics',
                        componentName: 'AllowedContainerTypes',
                        value: serviceCenter?.productMetrics?.map(({
                            productType,
                        }) => {
                            return productType
                        }),
                        labelKey: 'ServiceCenter.modeledProductTypes',
                    },
                ],
            },
            {
                id: 'confirm_order_2',
                fields: [
                    {
                        name: 'selectedOriginServiceCenterContacts',
                        componentName: 'MultipleContactObjectSelector',
                        labelKey: 'ServiceCenter.locationContacts',
                    },
                    {
                        name: 'operationalDays',
                        componentName: 'EnumSelector',
                        allowedValues: getAllowedValues(OperationalDays),
                        value: serviceCenter?.operationalDays,
                        labelKey: 'ServiceCenter.operationalDays',
                    },
                    {
                        name: 'orderSelectionDelay',
                        componentName: 'IntegerInput',
                        value: serviceCenter?.orderSelectionDelay,
                        labelKey: 'ServiceCenter.orderSelectionDelay',
                    },
                ],
            },
        ],
    }]
}

export default getFields
